<template lang="pug">
  .column
    section.section(v-if='!isCustom')
      .row.middle.space-between
        h2.text-big.m-bottom-2.bold {{ $t("feed.feedInitial.ephemeride") }}
        router-link.text-normal.bold.blue(:to='{name: routes.seeMore, query: {section: "ephemeride"}}')
          | {{ $t("feed.feedInitial.seeMore") }}
      .loader.grid.grid-columns-3.gap-20.relative(v-if='ephemeride.loading')
        sk-ephemeride-card(v-for='n in 3' :key='n')
        loader.absolute(size="inner")
      .grid.grid-columns-3.gap-20(v-else)
        ephemeride-card(
          v-for='folder in ephemeride.data'
          :key='folder.id'
          :id='folder.id'
          :image='folder.feedThumbnail'
          :name='folder.title'
          :startDate='folder.startDate'
          :folderLocale='folder.selectedLocale'
        )
    section.section(v-if='isCustom')
      .row.middle.space-between
        h2.text-big.m-bottom-2.bold {{ $t("feed.feedInitial.educationalPrograms") }}
        router-link.text-normal.bold.blue(:to='{name: routes.seeMore, query: {section: "educationalPrograms"}}')
          | {{ $t("feed.feedInitial.seeMore") }}
      .loader.grid.grid-columns-4.gap-20.relative(v-if='educationalPrograms.loading')
        sk-educational-program-card(v-for='n in 4' :key='n')
        loader.absolute(size="inner")
      .grid.grid-columns-4.gap-20(v-else)
        educational-program-card(
          v-for='program in educationalPrograms.data'
          :key='program.id' noMargin
          :program='program'
        )
    section.section(v-if='showBanner')
      invitation-banner
    section.section(v-if='!isCustom && mostViewedKimpleFolders.data.length')
      .row.middle.space-between
        h2.text-big.m-bottom-2.bold {{ $t("feed.feedInitial.mostViewedKimpleFolders") }}
        router-link.text-normal.bold.blue(
          v-if='mostViewedKimpleFolders.data.length === 4'
          :to='{name: routes.seeMore, query: {section: "mostViewedKimpleFolders"}}'
        ) {{ $t("feed.feedInitial.seeMore") }}
      .loader.grid.grid-columns-4.gap-20.relative(v-if='mostViewedKimpleFolders.loading')
        sk-folder-card(v-for='n in 4' :key='n')
        loader.absolute(size="inner")
      .grid.grid-columns-4.gap-20(v-else)
        kimple-folder-feed.m-bottom-2(
          v-for='folder in mostViewedKimpleFolders.data'
          noMargin
          :key='folder.id'
          :folder='folder'
          origin='Search results'
        )
    section.section(v-if='!isCustom && !mostViewedKimpleFolders.data.length')
      .row.middle.space-between
        h2.text-big.m-bottom-2.bold {{ $t("feed.feedInitial.lastFolders") }}
        router-link.text-normal.bold.blue(:to='{name: routes.seeMore, query: {section: "lastFolders"}}')
          | {{ $t("feed.feedInitial.seeMore") }}
      .loader.grid.grid-columns-4.gap-20.relative(v-if='lastFolders.loading')
        sk-folder-card(v-for='n in 4' :key='n')
        loader.absolute(size="inner")
      .grid.grid-columns-4.gap-20(v-else)
        kimple-folder-feed.m-bottom-2(
          v-for='folder in lastFolders.data'
          noMargin
          :key='folder.id'
          :folder='folder'
          origin='Search results'
        )
    section.section(v-if='!isCustom')
      .row.middle.space-between
        h2.text-big.m-bottom-2.bold {{ $t("feed.feedInitial.lastPrograms") }}
        router-link.text-normal.bold.blue(:to='{name: routes.seeMore, query: {section: "lastPrograms"}}')
          | {{ $t("feed.feedInitial.seeMore") }}
      .loader.grid.grid-columns-4.gap-20.relative(v-if='lastPrograms.loading')
        sk-educational-program-card(v-for='n in 4' :key='n')
        loader.absolute(size="inner")
      .grid.grid-columns-4.gap-20(v-else)
        educational-program-card(
          v-for='program in lastPrograms.data'
          :key='program.id' noMargin
          :program='program'
        )
    section.section.m-bottom-5(v-if='!isCustom && latestResourcesSeen.data.length')
      .row.middle.space-between
        h2.text-big.m-bottom-2.bold
          | {{ $t("feed.feedInitial.latestResourcesSeen") }}
        router-link.text-normal.bold.blue(
          v-if='latestResourcesSeen.data.length > 4'
          :to='{name: routes.seeMore, query: {section: "latestResourcesSeen"}}'
        ) {{ $t("feed.feedInitial.seeMore") }}
      .loader.grid.grid-columns-4.gap-20.relative(v-if='latestResourcesSeen.loading')
        sk-resource-card(v-for='n in 4' :key='n')
        loader.absolute(size="inner")
      .grid.grid-columns-4.gap-20(v-else)
        resource-card.m-bottom-2(
          v-for='resource in latestResourcesSeen.data.slice(0, 4)'
          :resource='resource' noMargin
          :bookmarked='resource.isInAnyFolder'
        )
    section.section.m-bottom-5(v-else-if='mostViewedResources.data.length && !isCustom')
      .row.middle.space-between
        h2.text-big.m-bottom-2.bold
          | {{ $t("feed.feedInitial.mostViewedResources") }}
        router-link.text-normal.bold.blue(
          v-if='mostViewedResources.data.length === 4'
          :to='{name: routes.seeMore, query: {section: "mostViewedResources"}}'
        ) {{ $t("feed.feedInitial.seeMore") }}
      .loader.grid.grid-columns-4.gap-20.relative(v-if='mostViewedResources.loading')
        sk-resource-card(v-for='n in 4' :key='n')
        loader.absolute(size="inner")
      .grid.grid-columns-4.gap-20(v-else)
        resource-card.m-bottom-2(
          v-for='resource in mostViewedResources.data'
          :resource='resource' noMargin
          :bookmarked='resource.isInAnyFolder'
        )
    section.section.m-bottom-5(v-else-if='!isCustom')
      .row.middle.space-between
        h2.text-big.m-bottom-2.bold
          | {{ $t("feed.feedInitial.newestResources") }}
        router-link.text-normal.bold.blue(
          v-if='newestResources.data.length === 4'
          :to='{name: routes.seeMore, query: {section: "newestResources"}}'
        ) {{ $t("feed.feedInitial.seeMore") }}
      .loader.grid.grid-columns-4.gap-20.relative(v-if='newestResources.loading')
        sk-resource-card(v-for='n in 4' :key='n')
        loader.absolute(size="inner")
      .grid.grid-columns-4.gap-20(v-else)
        resource-card.m-bottom-2(
          v-for='resource in newestResources.data'
          :resource='resource' noMargin
          :bookmarked='resource.isInAnyFolder'
        )
</template>

<script>
import ResourceCard from '@/components/ResourceCard'
import TopicCard from '@/components/TopicCard'
import KimpleFolderFeed from '@/components/KimpleFolderFeed'
import SdgCard from '@/components/SDGCard'
import EphemerideCard from '@/components/EphemerideCard'
import KimpleFolderCard from '@/components/KimpleFolderCard'
import { mapActions, mapState } from 'vuex'
import { sections } from '../../constants/newFeed'
import Loader from '../Loader'
import SkResourceCard from '../SkResourceCard'
import SkFolderCard from '../SkFolderCard'
import SkTopicCard from '../SkTopicCard'
import SkEphemerideCard from '../SkEphemerideCard'
import SkSdgCard from '../SkSdgCard'
import SkKimpleFolderCard from '../SkKimpleFolderCard'
import userRole from '../../mixins/userRole'
import EducationalProgramCard from '../EducationalProgramCard'
import SkEducationalProgramCard from '../SkEducationalProgramCard'
import { routes } from '../../router'

export default {
  mixins: [userRole],
  components: {
    Loader,
    EducationalProgramCard,
    SkEducationalProgramCard,
    KimpleFolderCard,
    ResourceCard,
    SkResourceCard,
    KimpleFolderFeed,
    SkFolderCard,
    TopicCard,
    SkTopicCard,
    SdgCard,
    SkSdgCard,
    SkKimpleFolderCard,
    EphemerideCard,
    SkEphemerideCard
  },
  data() {
    return {
      toastMessage: '',
      toastError: false,
      routes
    }
  },
  beforeDestroy() {
    this.clearFeedSections()
  },
  watch: {
    locale() {
      this.clearFeedSections()
      this.loadFeed()
    }
  },
  created() {
    this.loadFeed()
  },
  computed: {
    ...mapState({
      locale: state => state.behavior.locale,
      ephemeride: state => state.newFeed.sections.ephemeride,
      foldersRecommended: state => state.newFeed.sections.foldersRecommended,
      mostViewedKimpleFolders: state => state.newFeed.sections.mostViewedKimpleFolders,
      lastFolders: state => state.newFeed.sections.lastFolders,
      educationalPrograms: state => state.newFeed.sections.educationalPrograms,
      resources: state => state.newFeed.sections.resources,
      latestResourcesSeen: state => state.newFeed.sections.latestResourcesSeen,
      mostViewedResources: state => state.newFeed.sections.mostViewedResources,
      newestResources: state => state.newFeed.sections.newestResources,
      lastPrograms: state => state.newFeed.sections.lastPrograms,
      invitationCount: state => state.trial.invitedEmails.count
    }),
    showBanner() {
      return this.isTrial && this.remainingDays >= 7 && this.invitationCount < 4 && this.isMainTrial
    }
  },
  methods: {
    ...mapActions([
      'hydrateFeedSection',
      'clearFeedSections'
    ]),
    loadFeed() {
      const feedSections = sections.filter(sec => this.isCustom ? sec.customService : !sec.customService)
      for (const section of feedSections) {
        this.hydrateFeedSection({
          fromFeed: true,
          sectionName: section.name,
          isCustom: this.isCustom
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.section{
  padding: 25px 0;
}
</style>
